import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ListItem } from 'material-ui/List';
import muiThemeable from 'material-ui/styles/muiThemeable';
import { PAGE_PAGE } from '../../constants/routes';
import withTranslation from '../../hoc/withTranslation';
import style from '../../styles/styles';
import styles from './PageItem.css';
import MediasService from '../../services/medias';
import { Avatar, Chip } from 'material-ui';
import Pages from 'material-ui/svg-icons/communication/comment';

class PageItem extends React.Component {

    static propTypes = {
        page: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
    };

    // Render

    renderFirstMedia() {
        let page = this.props.page;

        if (page.medias) {
            let images = MediasService.sortedMediasForShortMime(page.medias, MediasService.IMAGES);

            if (images.length > 0) {
                return <Avatar src={images[0].link} style={style.image.cover} />;
            }
        }

        return <Avatar icon={<Pages />} />;
    }

    render() {
        const { page, app } = this.props;
        return (
            <Link
                to={PAGE_PAGE.replace(':appId', app.id).replace(':pageId',
                    this.props.page.id,
                )}>
                <ListItem
                    insetChildren={true}
                    leftAvatar={this.renderFirstMedia()}
                    primaryText={
                        <div>
                            {page.display_order + ': '}
                            {page.title || this.props.t('module.page.no_title')}
                            {page.tag &&
                                <Chip style={{...styles.chip, ...style.chip}}>
                                    {page.tag}
                                </Chip>
                            }
                        </div>
                    }
                    disableKeyboardFocus={true}
                >
                </ListItem>
            </Link>
        );
    }
}

export default muiThemeable()(withTranslation(PageItem));



// WEBPACK FOOTER //
// src/components/page/PageItem.js